import { __rest, __assign } from 'tslib';
import React__default, { useState } from 'react';
import { useFolderField } from '../../providers/fields/folder/hooks.js';
import TreeField from '../TreeField/index.js';
import { TreeFieldMode } from '../TreeField/types.js';

var FieldFolder = function (_a) {
    var initialFolderIds = _a.initialFolderIds, onChange = _a.onChange, KIcon = _a.KIcon, props = __rest(_a, ["initialFolderIds", "onChange", "KIcon"]);
    // Remove negative ids to avoid 400 http errors in the api folders search request
    var initialFolderIdsNew = initialFolderIds
        ? initialFolderIds === null || initialFolderIds === void 0 ? void 0 : initialFolderIds.filter(function (id) { return id > -1; })
        : [];
    var initialValue = useState(initialFolderIdsNew && initialFolderIdsNew.length > 0 ? initialFolderIdsNew : [])[0];
    var _b = useFolderField({
        folderIds: initialValue
    }), autocompleteOptions = _b.autocompleteOptions, setQuery = _b.setQuery, treeViewOptions = _b.treeViewOptions, setFolderId = _b.setFolderId, initialOptions = _b.initialOptions;
    return (React__default.createElement(TreeField, __assign({ testId: "FieldFolder", modes: [TreeFieldMode.TREE_VIEW], onChange: function (values) { return onChange(values && values.length > 0 ? values.map(function (v) { return v.id; }) : []); }, onAutocomplete: function (query) { return setQuery(query); }, values: initialOptions, options: treeViewOptions, autocompleteOptions: autocompleteOptions, getOptions: function (folderId) { return setFolderId(folderId); }, KIcon: KIcon }, props)));
};

export { FieldFolder as default };
//# sourceMappingURL=index.js.map
